/**
 * Workspace expense save — thin wrapper so receipt flows call one stable entry point.
 *
 * @param {((data: object, options?: object) => Promise<boolean>) | undefined} saveExpense
 * @param {object} expensePayload
 * @returns {Promise<boolean>}
 */
export async function saveProjectExpense(saveExpense, expensePayload) {
  if (!saveExpense) return false;
  return saveExpense(
    {
      ...expensePayload,
      updatedAt: new Date().toISOString(),
    },
    { skipUiReset: true }
  );
}
